import { SearchByRadius, SearchBenHospital } from "../../../Http/Index";

export const searchCompanyList = async (companyName: string, pageSize: number, pageNumber: number, radius: number) => {
    try {
        const res = await SearchByRadius(companyName, pageSize, pageNumber, radius)
        return res.data
    } catch (e) {
        throw e;
    }

}

export const searchBenHosp = async (companyId: string, pageSize: number, pageNumber: number) => {
    try {
        const res = await SearchBenHospital(companyId, pageSize, pageNumber);
        return res.data
    } catch (e) {
        throw e;
    }
}

export const getAllDataForQuery = async (companyId: string, radius: number, companyName: string) => {
    try {
        const res = await SearchByRadius(companyId, 10, 1, radius, companyName, true)
        return res.data
    } catch (e) {
        throw e;
    }

}

export const getAllHospitalMapData = async (companyId: string, companyName: string) => {
    try {
        const res = await SearchBenHospital(companyId, 1, 10, companyName, true);
        return res.data
    } catch (e) {
        throw e;
    }
}